import { render, staticRenderFns } from "./AlertDetailsDialog.vue?vue&type=template&id=58476d75&"
import script from "./AlertDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./AlertDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AlertDetailsDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports